<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Estimados de Venta</div>
      <div>
        <v-btn
          v-show="editMode === 'edit'"
          color="warning"
          outlined
          @click="cancel"
          class="mx-2"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-show="
            editMode === 'show' &&
              filterCampaign &&
              filterCrop &&
              filterCommercialPerson &&
              !filterProducerCategory &&
              canEdit === true
          "
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode === 'edit'"
          :disabled="saving"
          color="success"
          outlined
          @click="save"
          clss="mx-2"
        >
          Guardar
        </v-btn>
      </div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar v-show="editMode === 'show'">
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedCampaign"
            return-object
            @change="campaignSelected($event)"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedCrop"
            return-object
            @change="cropSelected($event)"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Comercial"
            :items="commercialPersonItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="commercial_person"
            v-model="selectedCommercialPerson"
            return-object
            @change="commercialPersonSelected($event)"
            ref="commercialPersonAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('commercialPersonAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-text-field
            hide-details
            prepend-icon="mdi-close"
            label="Productor"
            v-model="searchProducer"
            @click:prepend="clearSearchProducer"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Categoría"
            :items="producerCategoryItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            @change="producerCategorySelected($event)"
            ref="producerCategoryAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('producerCategoryAutocomplete')"
          ></v-autocomplete>
        </v-toolbar>
        <v-toolbar v-if="editMode === 'edit'">
          <v-text-field
            hide-details
            v-model="filterCampaign['description']"
            :readonly="true"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field
            hide-details
            v-model="filterCrop['description']"
            :readonly="true"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field
            hide-details
            v-model="filterCommercialPerson['name']"
            :readonly="true"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field
            hide-details
            prepend-icon="mdi-close"
            label="Productor"
            v-model="searchProducer"
            @click:prepend="clearSearchProducer"
          ></v-text-field>
          <v-progress-linear
            :active="loading || downloading || saving"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
        <!-- table header pagination and add button -->
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ activationEvents }">
              <v-btn
                v-show="editMode === 'edit'"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="activationEvents"
                @click="showProducer = !showProducer"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Agregar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ activationEvents }">
              <v-btn
                :loading="downloading"
                :disabled="downloading"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="activationEvents"
                @click="exportToExcel"
              >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span>Exportar</span>
          </v-tooltip>
        </div>
        <v-data-table
          dense
          :loading="loading"
          :headers="headers"
          :items="items"
          :items-per-page="itemsPerPage"
          :search="searchProducer"
        >
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer
              :pagination="pagination"
              :options="options"
              @update:options="updateOptions"
            />
          </template>
          <template slot="body.prepend">
            <tr>
              <th>Totales</th>
              <th v-show="filterCommercialPersonTypeLevel !== 3"></th>
              <th class="text-right">{{ sumField("previous_hectares") }}</th>
              <th class="text-right">{{ sumField("hectares") }}</th>
              <th class="text-right">{{ sumField("previous_sales") }}</th>
              <th class="text-right">{{ sumField("sales") }}</th>
              <th
                class="text-right"
                v-for="(col, col_index) in columns"
                :key="'total_' + col_index.toString()"
              >
                {{ sumField("col" + (col_index + 1).toString()) }}
              </th>
            </tr>
          </template>
          <template v-if="editMode === 'edit'" v-slot:body="{ items }">
            <tbody>
              <tr>
                <th>Totales</th>
                <th class="text-right">{{ sumField("previous_hectares") }}</th>
                <th class="text-right">{{ sumField("hectares") }}</th>
                <th class="text-right">{{ sumField("previous_sales") }}</th>
                <th class="text-right">{{ sumField("sales") }}</th>
                <th
                  class="text-right"
                  v-for="(col, col_index) in columns"
                  :key="'total_' + col_index.toString()"
                >
                  {{ sumField("col" + (col_index + 1).toString()) }}
                </th>
              </tr>
              <tr v-for="(item, item_index) in items" :key="item.name">
                <td>{{ item.producer_name }}</td>
                <td class="text-right">{{ item.previous_hectares }}</td>
                <td class="text-right">{{ item.hectares }}</td>
                <td class="text-right">{{ item.previous_sales }}</td>
                <td class="text-right">{{ item.sales }}</td>
                <td
                  v-for="(col, col_index) in columns"
                  :key="item_index.toString() + col_index.toString()"
                  class="text-right"
                >
                  <span v-show="!col.enabled">
                    {{ item["col" + (col_index + 1).toString()] }}
                  </span>
                  <v-text-field
                    v-show="col.enabled"
                    class="inputCol"
                    dense
                    :hide-details="true"
                    :single-line="true"
                    v-model="item['col' + (col_index + 1).toString()]"
                    type="number"
                    :id="
                      'R' + item_index.toString() + 'C' + col_index.toString()
                    "
                    @change="cellChange(item, col_index)"
                  ></v-text-field>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="showProducer"
      :show="showProducer"
      :title="searchOptions.title"
      :endpoint="searchOptions.endpoint"
      :ordering="searchOptions.ordeting"
      :searchLabel="searchOptions.searchLabel"
      :headers="searchOptions.headers"
      :filterString="searchOptions.filterstring"
      :canEdit="false"
      :canAdd="false"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";
import XLSX from "xlsx";

export default {
  name: "Estimation",

  components: {
    PaginatedSearchDialog
  },

  data() {
    return {
      editMode: "show",
      campaignItems: [],
      cropItems: [],
      commercialPersonItems: [],
      producerCategoryItems: [],
      filterCampaign: null,
      filterCrop: null,
      filterCommercialPerson: null,
      filterCommercialPersonTypeLevel: null,
      filterProducerCategory: null,
      selectedCampaign: null,
      selectedCrop: null,
      selectedCommercialPerson: null,
      selectedProducerCategory: null,
      loading: true,
      itemsPerPage: 100,
      options: {},
      items: [],
      headers: [],
      columns: [],
      canEdit: false,
      showProducer: false,
      downloading: false,
      saving: false,
      searchProducer: "",
      searchOptions: {
        title: "Buscar Productor",
        endpoint: "data/producers",
        ordering: "name",
        searchLabel: "CUIT/Nombre",
        headers: [
          { text: "Nombre", value: "name", sortable: false },
          { text: "CUIT", value: "identification", sortable: false },
          { text: "Tipo", value: "category_description", sortable: false }
        ],
        filterString: null
      }
    };
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI() {
      try {
        this.loading = true;
        if (
          this.filterCampaign &&
          this.filterCrop &&
          this.filterCommercialPerson
        ) {
          this.items = [];
          //Load Column Headers
          let columns = await this.$bRoot.search(
            "/data/estimations_columns",
            null,
            "number",
            "campaign__id=" + this.filterCampaign.id.toString()
          );

          if (columns.data.count !== 12) {
            this.canEdit = false;
            throw "Error recuperando configuración de columnas para " +
              this.filterCampaign.description.toString() +
              " contacte al administrador";
          }

          this.columns = [];
          columns.data.results.map(item => {
            this.columns.push({
              description: item.description,
              // eslint-disable-next-line
              from_formatted: this.$moment(item.editable_from).format("DD/MM/YYYY"),
              // eslint-disable-next-line
              to_formatted: this.$moment(item.editable_to).format("DD/MM/YYYY"),
              // eslint-disable-next-line
              enabled: this.$moment().isBetween(this.$moment(item.editable_from), this.$moment(item.editable_to))
            });
          });

          this.headers = [
            { text: "Productor", value: "producer_name", width: "30%" },
            // eslint-disable-next-line
            { text: "ha " + this.filterCampaign.previous_campaign_code, value: "previous_hectares", align: 'right' },
            // eslint-disable-next-line
            { text: "ha " + this.filterCampaign.code, value: "hectares", align: 'right' },
            // eslint-disable-next-line
            { text: "Ventas " + this.filterCampaign.previous_campaign_code, value: "previous_sales", align: 'right' },
            // eslint-disable-next-line
            { text: "Ventas " + this.filterCampaign.code, value: "sales", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[0].description, value: "col1", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[1].description, value: "col2", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[2].description, value: "col3", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[3].description, value: "col4", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[4].description, value: "col5", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[5].description, value: "col6", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[6].description, value: "col7", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[7].description, value: "col8", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[8].description, value: "col9", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[9].description, value: "col10", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[10].description, value: "col11", align: 'right' },
            // eslint-disable-next-line
            { text: this.columns[11].description, value: "col12", align: 'right' }
          ];
          if (this.filterCommercialPerson.commercial_type_level != 3) {
            // eslint-disable-next-line
            this.headers.unshift({text: "Agente", value: "commercial_person_name", width: "20%" })
          }
          //Load body
          let items = await this.$bRoot.search(
            "/data/estimations/all_producers" +
              "/" +
              this.filterCampaign.id.toString() +
              "/" +
              this.filterCommercialPerson.commercial_id.toString() +
              "/" +
              this.filterCrop.id.toString() +
              "/" +
              // eslint-disable-next-line
              (this.filterProducerCategory ? this.filterProducerCategory.id.toString() : 0)
          );
          this.items = items.data;
          this.canEdit =
            this.filterCampaign.current &&
            !(
              this.current_level === 4 &&
              this.$bRoot.appInfo.commercial_person.can_estimate_sale !== true
            ) &&
            this.filterCommercialPerson.commercial_type_level === 3;
        } else {
          this.items = [];
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    sumField(key) {
      return this.items.reduce((a, b) => a + (Number(b[key]) || 0), 0);
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "campaignAutocomplete":
          this.filterCampaign = null;
          break;
        case "commercialPersonAutocomplete":
          this.filterCommercialPerson = null;
          this.filterCommercialPersonTypeLevel = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          break;
        case "producerCategoryAutocomplete":
          this.filterProducerCategory = null;
          break;
      }
      this.readDataFromAPI();
    },

    clearSearchProducer() {
      this.searchProducer = "";
    },

    campaignSelected(item) {
      this.filterCampaign = item;
      this.readDataFromAPI();
    },

    commercialPersonSelected(item) {
      this.filterCommercialPerson = item;
      this.filterCommercialPersonTypeLevel = item.commercial_type_level;
      this.readDataFromAPI();
    },

    cropSelected(item) {
      this.filterCrop = item;
      this.readDataFromAPI();
    },

    producerCategorySelected(item) {
      this.filterProducerCategory = item;
      this.readDataFromAPI();
    },

    edit() {
      try {
        if (
          this.current_level === 4 &&
          this.$bRoot.appInfo.commercial_person.can_estimate_sale !== true
        ) {
          throw "Asistente no habilitado a editar información";
        }
        if (this.filterCampaign.current !== true) {
          throw "Campaña cerrada, no es posible editar datos";
        }
        this.editMode = "edit";
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    searchCanceled() {
      this.showProducer = false;
    },

    searchSelected(producer) {
      this.showProducer = false;
      try {
        let index = this.items.findIndex(
          item => item.producer_id === producer.id
        );
        if (index !== -1) {
          throw "El Productor " +
            producer.name +
            " ya posee estimaciones cargadas en la línea " +
            index.toString();
        } else {
          this.items.push({
            id: null,
            producer_id: producer.id,
            producer_name: producer.name,
            producer_identification_: producer.identification,
            producer_identification_type: producer.identification_type_code,
            hectares: null,
            previous_hectares: null,
            sales: null,
            previous_sales: null,
            col1: null,
            col2: null,
            col3: null,
            col4: null,
            col5: null,
            col6: null,
            col7: null,
            col8: null,
            col9: null,
            col10: null,
            col11: null,
            col12: null,
            code: null,
            changed: false
          });
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    cellChange(item, col_index) {
      item.changed = true;
      let val = item["col" + (col_index + 1).toString()];
      item["col" + (col_index + 1).toString()] = val == "" ? 0 : val;
    },

    async cancel() {
      // eslint-disable-next-line
      if(await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    endEdit() {
      this.editMode = "show";
      this.readDataFromAPI();
    },

    async save() {
      try {
        // save
        this.saving = true;
        let modified = [];
        this.items.map(item => {
          if (item.changed === true) {
            modified.push({
              col1: item.col1,
              col2: item.col2,
              col3: item.col3,
              col4: item.col4,
              col5: item.col5,
              col6: item.col6,
              col7: item.col7,
              col8: item.col8,
              col9: item.col9,
              col10: item.col10,
              col11: item.col11,
              col12: item.col12,
              commercial_person_id: this.filterCommercialPerson.commercial_id,
              campaign_id: this.filterCampaign.id,
              crop_id: this.filterCrop.id,
              producer_id: item.producer_id,
              code: item.code
            });
          }
        });
        await this.$bRoot.axios.put("/data/estimations/bulk/", modified);
        this.saving = false;
        this.endEdit();
      } catch (error) {
        this.saving = false;
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
          return null;
        }
      }
    },

    async exportToExcel() {
      try {
        this.downloading = true;
        if (this.items.length > 0) {
          let datos = [];
          this.items.map(item => {
            let element = {
              Agente: item.commercial_person_name,
              Productor_CUIT: item.producer_identification,
              Productor_Nombre: item.producer_name,
              Productor_Categoria: item.producer_category_description,
              Cultivo: this.filterCrop ? this.filterCrop.description : "?"
            };
            // eslint-disable-next-line
            element["ha " + this.filterCampaign.previous_campaign_code] = item.previous_hectares;
            element["ha " + this.filterCampaign.code] = item.hectares;
            element["Ventas " + this.filterCampaign.previous_campaign_code] =
              item.previous_sales;
            element["Ventas " + this.filterCampaign.code] = item.sales;
            element[this.columns[0].description] = item.col1;
            element[this.columns[1].description] = item.col2;
            element[this.columns[2].description] = item.col3;
            element[this.columns[3].description] = item.col4;
            element[this.columns[4].description] = item.col5;
            element[this.columns[5].description] = item.col6;
            element[this.columns[6].description] = item.col7;
            element[this.columns[7].description] = item.col8;
            element[this.columns[8].description] = item.col9;
            element[this.columns[9].description] = item.col10;
            element[this.columns[10].description] = item.col11;
            element[this.columns[11].description] = item.col12;

            datos.push(element);
          });

          // eslint-disable-next-line
          let datosWS = XLSX.utils.json_to_sheet(datos);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, datosWS, "estimados");
          XLSX.writeFile(wb, "estimados.xlsx");
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.downloading = false;
      }
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.current_level = this.$bRoot.auth.current_level;
    let campaigns = null,
      crops = null,
      commercialPersons = null,
      index = -1;

    try {
      //load campaigns
      campaigns = await this.$bRoot.search("/data/campaigns", null, "-code");
      this.campaignItems = campaigns.data.results;

      //set default
      let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      index = this.campaignItems.findIndex(
        item => item.id == defaultCampaignId
      );
      if (index == -1) {
        index = this.campaignItems.findIndex(item => item.current === true);
      }
      if (index !== -1) {
        this.selectedCampaign = this.campaignItems[index].url;
        this.filterCampaign = this.campaignItems[index];
      }

      //load crops
      crops = await this.$bRoot.search("/data/crops", null, "description");
      this.cropItems = crops.data.results;

      //set default
      let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      index = this.cropItems.findIndex(item => item.id === defaultCropId);
      if (index !== -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }

      //load commercial_persons
      commercialPersons = await this.$bRoot.searchAll(
        "/data/commercial_persons_hierarchy",
        null,
        "name",
        "commercial_type_level__lt=4"
      );
      this.commercialPersonItems = commercialPersons;

      //load categories
      let Categories = await this.$bRoot.searchAll(
        "/data/categories",
        null,
        "description"
      );
      this.producerCategoryItems = Categories;

      //set default
      index = this.commercialPersonItems.findIndex(
        // eslint-disable-next-line
        item => item.commercial_id === (this.current_level === 4 ? this.$bRoot.appInfo.commercial_person.superior_id : this.$bRoot.appInfo.commercial_person.id)
      );
      if (index !== -1) {
        // eslint-disable-next-line
        this.selectedCommercialPerson = this.commercialPersonItems[index].commercial_person;
        this.filterCommercialPerson = this.commercialPersonItems[index];
        this.filterCommercialPersonTypeLevel = this.filterCommercialPerson.commercial_type_level;
      }
      await this.readDataFromAPI();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style>
.v-data-footer__select {
  visibility: hidden !important;
}
.v-data-footer:last-child {
  visibility: hidden !important;
}
.table-footer-prepend {
  height: 58px;
}
.v-data-table {
  margin-top: -58px;
}
.inputCol input[type="number"] {
  -moz-appearance: textfield;
  text-align: right;
  width: 50px;
}
.inputCol input::-webkit-outer-spin-button,
.inputCol input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
